import ContentAdd from '@material-ui/icons/Add'
import { SplitButton } from 'opensolar-ui'
import { useDataProvider } from 'ra-core'
import { useCallback, useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { doNotTranslate } from 'util/misc'
import { StructType } from './hooks/useStructTypes'

const SINGULAR_LIST_LIMIT = 10000

type SplitOption = { label: React.ReactNode; value: string; disabled?: boolean }

export const SingularCreateButton = ({ singularStructTypes }) => {
  const dataProvider = useDataProvider()
  const [uncreatedTypes, setUncreatedTypes] = useState<StructType[]>([])
  const [loading, setLoading] = useState(false)
  const history = useHistory()

  const fetchUncreated = useCallback(() => {
    if (singularStructTypes.length === 0) return
    setLoading(true)
    const type__in = singularStructTypes.map((t) => t.id).join(',')
    dataProvider
      .getList('structs', {
        filter: { type__in, show_archived: 1 },
        pagination: { page: 1, perPage: SINGULAR_LIST_LIMIT },
        sort: { field: 'type', order: 'ASC' },
      })
      .then(({ data }) => {
        const existingTypes = new Set((data || []).map((r) => r.type))
        setUncreatedTypes(singularStructTypes.filter((t) => !existingTypes.has(t.id)))
        setLoading(false)
      })
      .catch(() => setLoading(false))
  }, [singularStructTypes, dataProvider])

  useEffect(() => {
    fetchUncreated()
  }, [fetchUncreated])

  const handleSelect = useCallback((item: SplitOption, _index: number) => {
    if (item.value && !item.disabled) {
      history.push(`/structs/${item.value}/create`)
    }
  }, [])

  if (singularStructTypes.length === 0) return null

  const options: SplitOption[] = loading
    ? [{ label: doNotTranslate('Loading...'), value: '', disabled: true }]
    : uncreatedTypes.length === 0
    ? [{ label: doNotTranslate('All Created'), value: '', disabled: true }]
    : uncreatedTypes.map((t, i) => ({
        label:
          i === 0 ? (
            <>
              <ContentAdd style={{ marginRight: 4, verticalAlign: 'middle' }} />
              {t.title}
            </>
          ) : (
            t.title
          ),
        value: t.id,
      }))

  const showSelected = !loading && uncreatedTypes.length <= 1 && uncreatedTypes.length > 0

  return (
    <div style={{ margin: 5, display: 'inline-block' }}>
      <SplitButton<string, SplitOption>
        options={options}
        selectedIndex={0}
        onClick={handleSelect}
        optionDisabled="disabled"
        showSelected={showSelected}
        variant="outlined"
        color="default"
        size="medium"
        style={{ width: '220px' }}
      />
    </div>
  )
}
